import {fetchAPI} from "./API";

export const famillesService = {
    getAll,
};

function getAll(){
    return fetchAPI('familles', "GET")
}
